import { Expose } from "class-transformer";
import { BaseModel } from "src/shared/models/base.model";

export class Voucher extends BaseModel {
    @Expose() id = -1;

    @Expose() number = -1;

    @Expose() paymentDate = "";

    @Expose() serial = "";

    @Expose() urlFile = "";
}
